import * as R from 'ramda'
import * as RE from 'helpers/ramda-ext'
import {
  DEFAULT_PARTICIPANTS_CATEGORY,
  DEFAULT_PARTICIPANTS_VALUES,
  PARTICIPANTS_CATEGORIES
} from 'constants/participants'

export const getNbMissingBirthdatesForCategory = (category) => (
  category.number - category.birthdates.length
)

export const getNbParticipants = R.pipe(
  R.map(R.prop('number')),
  R.values,
  R.sum
)

const hasEnoughBirthdates = (category) => (selection) => R.compose(
  R.lte(selection[category].number),
  R.length,
  RE.rejectNil,
  R.path([category, 'birthdates'])
)(selection)

export const hasEnoughAdultsBirthdates = hasEnoughBirthdates('adults')
export const hasEnoughChildrenBirthdates = hasEnoughBirthdates('children')
export const hasEnoughBabiesBirthdates = hasEnoughBirthdates('babies')

const baseLevels = ['adults', 'children', 'babies']

const levels = (conf) => baseLevels.filter(
  name => conf[name].visible
)

const getFirstPossibility = (subset, currentLevel, conf) => {
  if (Array.isArray(subset)) { return { [levels(conf)[currentLevel]]: { number: subset[0] } } }

  const firstPair = R.toPairs(subset)[0]
  return {
    ...getFirstPossibility(firstPair[1], currentLevel + 1, conf),
    [levels(conf)[currentLevel]]: { number: parseInt(firstPair[0], 10) }
  }
}

const checkDefaultPossibility = (subset, currentLevel, defaultPossibility) => {
  const defaultPossibilityValue = R.path([baseLevels[currentLevel], 'number'], defaultPossibility)

  if (Array.isArray(subset)) { return [subset.includes(defaultPossibilityValue)] }

  if (R.prop(defaultPossibilityValue)(subset)) {
    const newSubset = R.prop(defaultPossibilityValue)(subset)
    return [
      ...checkDefaultPossibility(newSubset, currentLevel + 1, defaultPossibility),
      true
    ]
  }
  return [false]
}

// type GetFirstParticipantsPossibility = (
//   conf: ParticipantsPackageConfiguration,
//   defaultPossibility?: Participants,
//   minEqualsMax: boolean,
//   rules: ParticipantsPackageRules
// ) => Participants
export const getFirstParticipantsPossibility = (
  conf,
  defaultPossibility = DEFAULT_PARTICIPANTS_VALUES,
  minEqualsMax,
  rules
) => {
  if (R.isEmpty(rules) || R.isNil(rules)) {
    return defaultPossibility
  }

  const defaultPossible = checkDefaultPossibility(rules, 0, defaultPossibility)

  if (R.contains(false, defaultPossible)) {
    return (minEqualsMax)
      ? DEFAULT_PARTICIPANTS_VALUES
      : RE.mergeDeep(defaultPossibility, getFirstPossibility(rules, 0, conf))
  }

  return defaultPossibility
}

// type HasParticipantsSelectionValid = (
//   participantsSelection: Participants
// ) => boolean
export const hasParticipantsSelectionValid = (participantsSelection) => {
  const hasAtLeastOneDefaultParticipant = participantsSelection?.[DEFAULT_PARTICIPANTS_CATEGORY]?.number >= 1
  const hasAllParticipantsNumberDefined = PARTICIPANTS_CATEGORIES.every(category => typeof participantsSelection?.[category]?.number === 'number')

  return hasAtLeastOneDefaultParticipant && hasAllParticipantsNumberDefined
}

// type HasParticipantsSelectionPaxCountValid = (
//  minPax?: number,
//  maxPax?: number
// ) => (
//   participantsSelection: Participants,
// ) => boolean
export const hasParticipantsSelectionPaxCountValid = (minPax, maxPax) => (participantsSelection) => {
  if (
    !participantsSelection?.adults ||
    !participantsSelection?.children ||
    !participantsSelection?.babies
  ) {
    return false
  }

  const sumOfParticipants = PARTICIPANTS_CATEGORIES.reduce((sum, category) => sum + participantsSelection[category].number, 0)
  const isCompliantWithMinPax = minPax ? sumOfParticipants >= minPax : true
  const isCompliantWithMaxPax = maxPax ? sumOfParticipants <= maxPax : true

  return isCompliantWithMinPax && isCompliantWithMaxPax
}

export const getFormatParticipants = ({ adults, children, babies }) => `${adults.number}-${children.number}-${babies.number}`

// type HasAtLeastOneParticipant = { +[string]: number } => boolean
export const hasAtLeastOneParticipant = ({ adults, children, babies }) => ((adults || 0) + (children || 0) + (babies || 0) >= 1)

export const test = {
  levels
}
